import React, { useEffect, useState } from 'react';
import { Table, Spin, Card, Collapse, Typography } from 'antd';
import { WindowsOutlined, AppleOutlined } from '@ant-design/icons';
import { useTheme } from "../../context/ThemeContext";
import axios from '../../config/axiosInstance';

const { Title } = Typography;

const RegasusList = () => {
    const { darkTheme } = useTheme();
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchApps = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/apps/regasus');

                const data = response.data.map((item, index) => ({
                    key: index,
                    version: item.version,
                    platforms: item.platforms
                }));

                setApps(data);
            } catch (error) {
                console.error('Error fetching Regasus apps:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchApps();
    }, []);

    const downloadFile = (url) => {
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', '');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const renderPlatformIcons = (platforms) => (
        <>
            {platforms.map((platform) => {
                if (platform.type === 'windows') {
                    return (
                        <WindowsOutlined
                            key={`${platform.type}-${platform.link}`}
                            style={{
                                fontSize: '20px',
                                color: darkTheme ? '#00adef' : '#0078D6',
                                marginRight: '12px',
                                cursor: 'pointer'
                            }}
                            onClick={() => downloadFile(platform.link)}
                        />
                    );
                }

                if (platform.type === 'mac') {
                    return (
                        <AppleOutlined
                            key={`${platform.type}-${platform.link}`}
                            style={{
                                fontSize: '20px',
                                color: darkTheme ? '#FFFFFF' : '#000000',
                                marginRight: '12px',
                                cursor: 'pointer'
                            }}
                            onClick={() => downloadFile(platform.link)}
                        />
                    );
                }

                return null;
            })}
        </>
    );

    const columns = [
        {
            title: 'Version',
            dataIndex: 'version',
            key: 'version',
        },
        {
            title: 'Downloads',
            dataIndex: 'platforms',
            key: 'platform',
            render: (_, record) => renderPlatformIcons(record.platforms),
        },
    ];

    const collapseItems = [
        {
            key: 'regasus-versions',
            label: 'Available versions',
            children: loading ? (
                <Spin />
            ) : (
                <Table
                    columns={columns}
                    dataSource={apps}
                    pagination={false}
                />
            )
        }
    ];

    return (
        <Card
            style={{
                backgroundColor: darkTheme ? '#141414' : '#ffffff',
                border: darkTheme ? '1px solid #303030' : '1px solid #f0f0f0'
            }}
        >
            <Title level={4} style={{ marginTop: 0, marginBottom: 20 }}>
                Regasus RCP Client
            </Title>

            <Collapse
                items={collapseItems}
                ghost
            />
        </Card>
    );
};

export default RegasusList;